module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAACXBIWXMAAAsSAAALEgHS3X78AAAAZ0lEQVQoz+WSUQrAIAxDXzzRjuTRPKI3yH50SNEN/V0gtNWkLSi2GQlUwANr1KgJH0iyba3qjhI6f7HQkhxXmBHITb8/SbaXe0d0XeIAadZtFl9NR5N+b5J0AfRHjrHf0w53vlKxzQ1qV4V4V3VhbAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Trash.png
// module id = 143
// module chunks = 0 1